import fetch from '@/utils/fetch'
import qs from 'qs'
const exportPath = (url, params) => {
  return `${location.origin}/b/api/${url}?${qs.stringify(params)}`
}
/**查询学期课程*/
export function getCoursesWithSemestersGet(query) {
  return fetch({
    url: '/teacher/getCoursesWithSemesters',
    method: 'get',
    params: query
  });
}

/**查询学期*/
export function getSemestersGet(query) {
  return fetch({
    url: '/teacher/getSemesters',
    method: 'get',
    params: query
  });
}

/**查询学期班级*/
export function getClassesGet(query) {
  return fetch({
    url: '/teacher/getClasses',
    method: 'get',
    params: query
  });
}

/**查询课程班级课件*/
export function getClassesForCoursewareGet(query) {
  return fetch({
    url: '/teacher/getClassesForCourseware',
    method: 'get',
    params: query
  });
}
/**获取学届*/
export function getPeriod(query) {
  return fetch({
    url: '/teacher/getPeriod',
    method: 'get',
    params: query
  });
}
/**根据学届获取班级*/
export function getClassesWithPeriod(query) {
  return fetch({
    url: '/teacher/getClassesWithPeriod',
    method: 'get',
    params: query
  });
}
/**根据学届获取课程*/
export function getCoursesWithPeriod(query) {
  return fetch({
    url: '/teacher/getCoursesWithPeriod',
    method: 'get',
    params: query
  });
}
/**我的班级-全日制-花名册-列表接口*/
export function getFulltimeClassStudentRoster(query) {
  return fetch({
    url: '/teacher/getFulltimeClassStudentRoster',
    method: 'get',
    params: query
  });
}
/**我的班级-全日制-花名册-学生属性接口*/
export function getFulltimeStudentProperty(query) {
  return fetch({
    url: '/teacher/getFulltimeStudentProperty',
    method: 'get',
    params: query
  });
}
/**我的班级-全日制-花名册-学员在读班级*/
export function getStudentClassList(query) {
  return fetch({
    url: '/teacher/getStudentClassList',
    method: 'get',
    params: query
  });
}
/**我的班级-全日制-花名册-导出接口*/
export function exportFulltimeClassStudentRoster(query) {
  return exportPath('teacher/exportFulltimeClassStudentRoster', query)

}

// 班级学生积分周榜
export function getClassStudentWeeklyRankList (params) {
  return fetch({
    url: '/teacher/getClassStudentWeeklyRankList',
    method: 'get',
    params
  })
}
// 班级学生积分月榜
export function getClassStudentMonthlyRankList (params) {
  return fetch({
    url: '/teacher/getClassStudentMonthlyRankList',
    method: 'get',
    params
  })
}
// 班级学生积分总榜
export function getClassStudentTotalRankList (params) {
  return fetch({
    url: '/teacher/getClassStudentTotalRankList',
    method: 'get',
    params
  })
}
// 校区学生积分周榜
export function getSchoolStudentWeeklyRankList (params) {
  return fetch({
    url: '/teacher/getSchoolStudentWeeklyRankList',
    method: 'get',
    params
  })
}
// 校区学生积分月榜
export function getSchoolStudentMonthlyRankList (params) {
  return fetch({
    url: '/teacher/getSchoolStudentMonthlyRankList',
    method: 'get',
    params
  })
}
// 校区学生积分总榜
export function getSchoolStudentTotalRankList (params) {
  return fetch({
    url: '/teacher/getSchoolStudentTotalRankList',
    method: 'get',
    params
  })
}
// 班级学生积分榜
export function getClassStudentRanking (params) {
  return fetch({
    url: '/teacher/getClassStudentRanking',
    method: 'get',
    params
  })
}
// 班级学生积分全榜-导出excel
export function exportClassStudentRanking (params) {
  return fetch({
    url: '/teacher/exportClassStudentRanking',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
// 学生积分明细
export function getStudentPointsDetail (params) {
  return fetch({
    url: '/teacher/getStudentPointsDetail',
    method: 'get',
    params
  })
}
// 保存学生到班状态
export function saveClassStudentRegister (data) {
  data = JSON.stringify(data)
  return fetch({
    url: '/teacher/saveClassStudentRegister',
    method: 'post',
    data
  })
}

export function getFulltimeClassStudentRosterDetail (params) {
  return fetch({
    url: '/teacher/getFulltimeClassStudentRosterDetail',
    method: 'get',
    params
  })
}
// 更新当前课程
export function updateCourseCurrent (data) {
  // data = JSON.stringify(data)
  return fetch({
    url: '/teacher/upDateCourseCurrent',
    method: 'post',
    data: JSON.stringify(data),
    params: data
  })
}
